import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
`;

export const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
`;

export const Col = styled.div`
  ${({ xs6 }) =>
    xs6 &&
    css`
      flex: 0 0 auto;
      width: 50%;
    `}
`;
